import React from "react";
// --- Import Components
import Login from "./Login/Login";

import style from "./Auth.module.sass";

function Auth() {
  return (
    <div className={style.authWrapper}>
      <Login />
    </div>
  );
}

export default Auth;
